import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';
import { firstValueFrom } from 'rxjs';
import { club } from '../models/club';
import { result } from '../models/result';
import { assessmentArea } from '../models/assessmentArea';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  constructor(private http:HttpClient, private configService:ConfigurationService) {
    this.baseUrl = this.configService.getApiEndpoint();
  }
  
  baseUrl:string;
  defaultPageSize:number = 100;

  async searchClubs():Promise<Array<club>> {
      let endpoint = `${this.baseUrl}/clubs`;
      let result = await firstValueFrom(this.http.post<club[]>(endpoint, null));
      return result;
  }

  async searchResults(assessmentArea:string):Promise<Array<result>> {
      let endpoint = `${this.baseUrl}/results`;
      let result = await firstValueFrom(this.http.post<result[]>(endpoint, { assessment_area: assessmentArea }));
      return result;
  }

  getAssessmentAreas():assessmentArea[] {
    return [
      { code:'FULLSWING', label: 'Full Swing' },
      { code: 'PUTTING', label: 'Putting' }
    ];
  }
}